import { CommonModule } from '@angular/common'
import {
  Component,
  Input,
  OnInit,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core'
import {
  FormArray,
  FormControl,
  FormGroup,
  ReactiveFormsModule,
} from '@angular/forms'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatSelectModule } from '@angular/material/select'
import { MatInputModule } from '@angular/material/input'
import { MatIconModule } from '@angular/material/icon'
import { MatButtonModule } from '@angular/material/button'
import { NapcsCode } from '../../../../types/plastics'
import { TranslationService } from '../../../../services/translation.service'

@Component({
  selector: 'app-plastic-resin',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
  ],
  templateUrl: './plastic-resin.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './plastic-resin.component.scss',
})
export class PlasticResinComponent implements OnInit {
  translationService = inject(TranslationService)

  @Input({ required: true }) resins?: FormArray<FormGroup>
  @Input() napcsCodes: Array<NapcsCode> = []
  @Input() sourceTypes: Record<string, string> = {}

  ngOnInit(): void {
    if (!this.resins) {
      throw new Error('PlasticResinComponent: resins FormArray is required')
    }
  }

  get resinsArray(): FormArray<FormGroup> {
    return this.requireResins()
  }

  addResin(): void {
    const arr = this.requireResins()
    const newResin = new FormGroup({
      napcsCodeId: new FormControl<string | null>(null),
      sourceType: new FormControl<string | null>(null),
      weightPerUnitKg: new FormControl<number | null>(null),
      isDerived: new FormControl<boolean>(false),
    })
    arr.push(newResin)
  }

  removeResin(index: number): void {
    const arr = this.requireResins()
    if (arr.length > 1) {
      arr.removeAt(index)
    }
  }

  private requireResins(): FormArray<FormGroup> {
    if (!this.resins) {
      throw new Error('resins FormArray is missing')
    }
    return this.resins
  }
}
